import GitHub from "../assets/github.png";
import Python from "../assets/python.png";
import Java from "../assets/java.png";
import CSharp from "../assets/csharp.png";
import Selenium from "../assets/selenium.png";
import Playwright from "../assets/playwright.png";
import Docker from "../assets/docker.png";
import TypeScript from "../assets/typescript.png";
import RestAssured from "../assets/restassured.png";
import MySQL from "../assets/mysql.png";
import Jenkins from "../assets/jenkins.png";
import AzureDevOps from "../assets/azuredevops.png";
import JavaScript from "../assets/javascript.png";
import ReactImg from "../assets/react.png";
import Node from "../assets/node.png";
import AWS from "../assets/aws.png";
import Bootstrap from "../assets/bootstrap.png";
import MongoDB from "../assets/mongodb.png";
import ExpressJS from "../assets/expressjs.png";
import Tailwind from "../assets/tailwind.png";
import BITBUCKET from "../assets/bitbucket.png";

export const sdetSkills = [
  { id: 1, image: Playwright, name: "PLAYWRIGHT" },
  { id: 2, image: Selenium, name: "SELENIUM" },
  { id: 3, image: TypeScript, name: "TYPESCRIPT" },
  { id: 4, image: Java, name: "JAVA" },
  { id: 5, image: CSharp, name: "C#" },
  { id: 6, image: Python, name: "PYTHON" },
  { id: 7, image: RestAssured, name: "RESTASSURED" },
  { id: 8, image: MySQL, name: "MySQL" },
  { id: 9, image: Jenkins, name: "JENKINS" },
  { id: 10, image: AzureDevOps, name: "AZURE DEVOPS" },
  { id: 11, image: GitHub, name: "GITHUB" },
  { id: 12, image: Docker, name: "DOCKER" },
];

export const fullStackSkills = [
  { id: 1, image: JavaScript, name: "JAVASCRIPT" },
  { id: 2, image: Bootstrap, name: "BOOTSTRAP" },
  { id: 3, image: Tailwind, name: "TAILWIND" },
  { id: 4, image: ReactImg, name: "REACT" },
  { id: 5, image: Node, name: "NODE" },
  { id: 6, image: MongoDB, name: "MONGODB" },
  { id: 7, image: ExpressJS, name: "EXPRESSJS" },
  { id: 8, image: AWS, name: "AWS" },
  { id: 9, image: BITBUCKET, name: "BITBUCKET" },
];
